import script from "./AppPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPopup.vue?vue&type=script&setup=true&lang=js"

import "./AppPopup.vue?vue&type=style&index=0&id=32c94e85&lang=css"

const __exports__ = script;

export default __exports__